(function () {
  "use strict";
  function ready(fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    /* Gallery: swipe + dots + arrows */
    var gal = document.querySelector("[data-gal]");
    if (gal) {
      var track = gal.querySelector("[data-gal-track]");
      var slides = gal.querySelectorAll("[data-gal-slide]");
      var dots = gal.querySelectorAll("[data-gal-dot]");
      var cur = 0;
      var go = function (i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
      };
      var sync = function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== cur) {
          cur = i;
          dots.forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
        }
      };
      track.addEventListener("scroll", function () { window.requestAnimationFrame(sync); }, { passive: true });
      dots.forEach(function (d) { d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-gal-dot"), 10)); }); });
      var prev = gal.querySelector("[data-gal-prev]"), next = gal.querySelector("[data-gal-next]");
      if (prev) prev.addEventListener("click", function () { go(cur - 1); });
      if (next) next.addEventListener("click", function () { go(cur + 1); });
    }

    /* Tier picker → quantity + sticky total */
    var tiers = document.querySelector("[data-tiers]");
    var qty = document.querySelector("[data-qty]");
    var stickyTotal = document.querySelector("[data-sticky-total]");
    if (tiers) {
      tiers.addEventListener("change", function (e) {
        var input = e.target.closest("input[type=radio]");
        if (!input) return;
        tiers.querySelectorAll("[data-tier]").forEach(function (t) { t.classList.toggle("is-on", t.contains(input)); });
        if (qty) qty.value = input.value;
        var total = input.closest("[data-tier]").getAttribute("data-total");
        if (stickyTotal && total) stickyTotal.textContent = total;
      });
    }

    /* Buy it now vs Add to cart (same form, different return_to) */
    var form = document.getElementById("hg-buy-form");
    var ret = document.querySelector("[data-return]");
    var buyNow = document.querySelector("[data-buynow]");
    var atc = document.querySelector("[data-atc]");
    var stickyBuy = document.querySelector("[data-sticky-buy]");
    if (form && ret) {
      if (buyNow) buyNow.addEventListener("click", function () { ret.value = "/checkout"; });
      if (atc) atc.addEventListener("click", function () { ret.value = "/cart"; });
      if (stickyBuy) stickyBuy.addEventListener("click", function () {
        ret.value = "/checkout";
        if (typeof form.requestSubmit === "function") form.requestSubmit(buyNow || undefined); else form.submit();
      });
    }
  });
})();
